// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useModuleParty } from '../../contexts/ModuleContext';
import { useUserState } from '../../contexts/UserContext';
import { Notifications } from '../Notifications';
import { useCopyToClipboard } from '../useCopyToClipboard';
import { CantonBalance } from './CantonBalance';
import { DappGatewayButton } from './DappGatewayButton';
import { ProfilePopover } from './ProfilePopover';

export const HeaderContent: React.FC = () => {
  const party = useModuleParty();
  const { loggedInUser } = useUserState();
  const copy = useCopyToClipboard();
  const onClick = () => copy(party);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'hidden',
        ml: 'auto',
        pl: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          whiteSpace: 'nowrap',
        }}
      >
        <CantonBalance />
      </Box>
      <Box
        sx={{
          display: 'flex',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={(t) => ({
            borderRadius: 100,
            border: `1px solid ${t.palette.divider}`,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            whiteSpace: 'nowrap',
          })}
        >
          <Tooltip onClick={onClick} title={`Click to copy Party Id: ${party}`}>
            <Typography
              color="primary"
              fontWeight="bold"
              variant="caption"
              sx={{
                cursor: 'pointer',
                pl: 1,
                maxWidth: '180px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {party}
            </Typography>
          </Tooltip>
          <ProfilePopover />
        </Box>
      </Box>
      <Notifications />
      {loggedInUser?.isConnectedViaDapp && <DappGatewayButton />}
    </Box>
  );
};
